import { render, staticRenderFns } from "./payment-inquiry-list.vue?vue&type=template&id=b2d45b26&scoped=true&"
import script from "./payment-inquiry-list.vue?vue&type=script&lang=js&"
export * from "./payment-inquiry-list.vue?vue&type=script&lang=js&"
import style0 from "./payment-inquiry-list.vue?vue&type=style&index=0&id=b2d45b26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d45b26",
  null
  
)

export default component.exports